(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birdsong-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.birdsong-bundle-builder');
    if (!section) return;

    // State
    let teaSize = 'sampler';
    let boxSize = 5;
    let selectedTeas = [];
    let currentFilter = 'all';
    let activePreset = null;

    // DOM Elements
    const sizeOptions = section.querySelectorAll('[data-size-option]');
    const boxOptions = section.querySelectorAll('[data-box-option]');
    const filterTabs = section.querySelectorAll('[data-filter]');
    const teaCards = section.querySelectorAll('[data-tea-card]');
    const presetBundles = section.querySelectorAll('[data-preset-bundle]');
    const boxSlots = section.querySelector('[data-box-slots]');
    const selectedItems = section.querySelector('[data-selected-items]');
    const progressFill = section.querySelector('[data-progress-fill]');
    const progressCount = section.querySelector('[data-progress-count]');
    const progressBar = section.querySelector('[data-progress-bar]');
    const pricingSection = section.querySelector('[data-pricing-section]');
    const subtotalEl = section.querySelector('[data-subtotal]');
    const discountEl = section.querySelector('[data-discount]');
    const totalEl = section.querySelector('[data-total]');
    const addToCartBtn = section.querySelector('[data-add-to-cart-btn]');
    const configSize = section.querySelector('[data-config-size]');
    const configBox = section.querySelector('[data-config-box]');

    // Get base price for current tea size
    function getBasePrice() {
      const selected = section.querySelector('[data-size-option].selected');
      return selected ? parseInt(selected.dataset.basePrice, 10) : 800;
    }

    // Get discount for current box size
    function getDiscount() {
      const selected = section.querySelector('[data-box-option].selected');
      return selected ? parseInt(selected.dataset.discount, 10) / 100 : 0.15;
    }

    // Format money
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(0);
    }

    // Update box option prices
    function updateBoxPrices() {
      const basePrice = getBasePrice();
      boxOptions.forEach(option => {
        const count = parseInt(option.dataset.teaCount, 10);
        const discount = parseInt(option.dataset.discount, 10) / 100;
        const discountedPrice = Math.round(basePrice * count * (1 - discount));
        const priceEl = option.querySelector('[data-box-price]');
        if (priceEl) {
          priceEl.textContent = formatMoney(discountedPrice);
        }
      });
    }

    // Update tea card prices
    function updateTeaPrices() {
      teaCards.forEach(card => {
        const priceKey = 'price' + teaSize.charAt(0).toUpperCase() + teaSize.slice(1);
        const price = parseInt(card.dataset[priceKey.replace('-', '')] || card.dataset.priceSampler, 10);
        const priceEl = card.querySelector('[data-tea-price]');
        if (priceEl) {
          priceEl.textContent = formatMoney(price);
        }
      });
    }

    // Update UI
    function updateUI() {
      const count = selectedTeas.length;
      const isComplete = count === boxSize;
      const basePrice = getBasePrice();
      const discount = getDiscount();

      // Update config display
      const sizeOption = section.querySelector('[data-size-option].selected');
      if (configSize && sizeOption) {
        configSize.textContent = sizeOption.dataset.sizeName;
      }
      if (configBox) {
        configBox.textContent = boxSize + ' teas';
      }

      // Update progress
      if (progressCount) {
        progressCount.textContent = count + ' / ' + boxSize;
      }
      if (progressFill) {
        progressFill.style.width = (count / boxSize * 100) + '%';
      }
      if (progressBar) {
        progressBar.classList.toggle('complete', isComplete);
      }

      // Update box slots
      if (boxSlots) {
        let slotsHtml = '';
        for (let i = 0; i < boxSize; i++) {
          const teaData = selectedTeas[i];
          if (teaData) {
            slotsHtml += '<div class="birdsong-box-slot filled"><svg viewBox="0 0 50 60" fill="none"><rect x="5" y="5" width="40" height="45" rx="4" fill="' + teaData.color + '" opacity="0.5"/><rect x="10" y="10" width="30" height="30" rx="2" fill="' + teaData.color + '" opacity="0.7"/></svg></div>';
          } else {
            slotsHtml += '<div class="birdsong-box-slot"><span class="birdsong-box-slot__empty">+</span></div>';
          }
        }
        boxSlots.innerHTML = slotsHtml;
      }

      // Update selected items list
      if (selectedItems) {
        if (count === 0) {
          selectedItems.innerHTML = '<div class="birdsong-empty-box-message"><p>Pick a preset or build your own</p></div>';
          if (pricingSection) pricingSection.style.display = 'none';
        } else {
          let itemsHtml = '';
          selectedTeas.forEach((tea, index) => {
            itemsHtml += '<div class="birdsong-selected-item"><div class="birdsong-selected-item__color" style="background:' + tea.color + '"></div><span class="birdsong-selected-item__name">' + tea.title + '</span><button type="button" class="birdsong-selected-item__remove" data-remove-index="' + index + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>';
          });
          selectedItems.innerHTML = itemsHtml;
          if (pricingSection) pricingSection.style.display = 'block';

          // Bind remove events
          selectedItems.querySelectorAll('[data-remove-index]').forEach(btn => {
            btn.addEventListener('click', function() {
              const index = parseInt(this.dataset.removeIndex, 10);
              removeTeaAtIndex(index);
            });
          });
        }
      }

      // Update pricing
      const subtotal = count * basePrice;
      const discountAmount = isComplete ? Math.round(subtotal * discount) : 0;
      const total = subtotal - discountAmount;

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
      if (discountEl) {
        discountEl.textContent = isComplete ? '-' + formatMoney(discountAmount) + ' (' + Math.round(discount * 100) + '% off)' : '-$0';
      }
      if (totalEl) totalEl.textContent = formatMoney(total);

      // Update add to cart button
      if (addToCartBtn) {
        if (isComplete) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.add('ready');
          addToCartBtn.textContent = 'Add to Cart — ' + formatMoney(total);
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.remove('ready');
          const remaining = boxSize - count;
          addToCartBtn.textContent = 'Select ' + remaining + ' more tea' + (remaining > 1 ? 's' : '') + ' to continue';
        }
      }

      // Update tea cards
      updateTeaCards();
    }

    // Update tea card states
    function updateTeaCards() {
      teaCards.forEach(card => {
        const productId = card.dataset.productId;
        const teaCount = selectedTeas.filter(t => t.productId === productId).length;
        const qtyEl = card.querySelector('[data-tea-qty]');
        const removeBtn = card.querySelector('[data-remove-tea]');
        const addBtn = card.querySelector('[data-add-tea]');

        if (teaCount > 0) {
          card.classList.add('in-box');
          if (qtyEl) {
            qtyEl.style.display = 'flex';
            qtyEl.textContent = teaCount;
          }
          if (removeBtn) removeBtn.style.display = 'flex';
        } else {
          card.classList.remove('in-box');
          if (qtyEl) qtyEl.style.display = 'none';
          if (removeBtn) removeBtn.style.display = 'none';
        }

        if (addBtn) {
          addBtn.disabled = selectedTeas.length >= boxSize;
        }
      });
    }

    // Filter teas
    function filterTeas(filter) {
      currentFilter = filter;
      teaCards.forEach(card => {
        const type = card.dataset.teaType;
        if (filter === 'all' || type === filter || type.includes(filter)) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    }

    // Add tea
    function addTea(card) {
      if (selectedTeas.length >= boxSize) return;

      const teaData = {
        productId: card.dataset.productId,
        handle: card.dataset.productHandle,
        title: card.dataset.productTitle,
        color: card.dataset.teaColor,
        variantId: card.dataset['variant' + teaSize.charAt(0).toUpperCase() + teaSize.slice(1).replace('-', '')] || card.dataset.variantSampler
      };

      selectedTeas.push(teaData);
      activePreset = null;
      updatePresets();
      updateUI();
    }

    // Remove tea
    function removeTea(card) {
      const productId = card.dataset.productId;
      const index = selectedTeas.findIndex(t => t.productId === productId);
      if (index > -1) {
        selectedTeas.splice(index, 1);
        activePreset = null;
        updatePresets();
        updateUI();
      }
    }

    // Remove tea at index
    function removeTeaAtIndex(index) {
      selectedTeas.splice(index, 1);
      activePreset = null;
      updatePresets();
      updateUI();
    }

    // Update presets
    function updatePresets() {
      presetBundles.forEach(bundle => {
        bundle.classList.toggle('selected', bundle.dataset.presetId === activePreset);
        // Show/hide based on box size
        const forBoxSize = parseInt(bundle.dataset.presetBoxSize, 10);
        bundle.style.display = forBoxSize === boxSize ? 'block' : 'none';
      });
    }

    // Load preset
    function loadPreset(bundle) {
      const handles = bundle.dataset.presetTeas.split(',').map(h => h.trim());
      selectedTeas = [];

      handles.forEach(handle => {
        const card = section.querySelector('[data-product-handle="' + handle + '"]');
        if (card) {
          selectedTeas.push({
            productId: card.dataset.productId,
            handle: card.dataset.productHandle,
            title: card.dataset.productTitle,
            color: card.dataset.teaColor,
            variantId: card.dataset['variant' + teaSize.charAt(0).toUpperCase() + teaSize.slice(1).replace('-', '')] || card.dataset.variantSampler
          });
        }
      });

      activePreset = bundle.dataset.presetId;
      updatePresets();
      updateUI();
    }

    // Add to cart
    async function addToCart() {
      if (selectedTeas.length !== boxSize) return;

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      try {
        const items = selectedTeas.map(tea => ({
          id: parseInt(tea.variantId, 10),
          quantity: 1,
          properties: {
            '_bundle': 'Tea Box Bundle',
            '_bundle_size': boxSize + ' teas'
          }
        }));

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (response.ok) {
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          // Show success
          addToCartBtn.textContent = 'Added to Cart!';
          addToCartBtn.classList.add('ready');

          // Reset after delay
          setTimeout(() => {
            selectedTeas = [];
            activePreset = null;
            updatePresets();
            updateUI();
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        addToCartBtn.textContent = 'Error - Try Again';
        setTimeout(() => updateUI(), 2000);
      }
    }

    // Event Listeners
    sizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        sizeOptions.forEach(o => o.classList.remove('selected'));
        this.classList.add('selected');
        teaSize = this.dataset.sizeId;
        updateBoxPrices();
        updateTeaPrices();
        updateUI();
      });
    });

    boxOptions.forEach(option => {
      option.addEventListener('click', function() {
        boxOptions.forEach(o => o.classList.remove('selected'));
        this.classList.add('selected');
        const newSize = parseInt(this.dataset.teaCount, 10);
        if (selectedTeas.length > newSize) {
          selectedTeas = selectedTeas.slice(0, newSize);
          activePreset = null;
        }
        boxSize = newSize;
        updatePresets();
        updateUI();
      });
    });

    filterTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        filterTabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        filterTeas(this.dataset.filter);
      });
    });

    teaCards.forEach(card => {
      const addBtn = card.querySelector('[data-add-tea]');
      const removeBtn = card.querySelector('[data-remove-tea]');

      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          addTea(card);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          removeTea(card);
        });
      }
    });

    presetBundles.forEach(bundle => {
      bundle.addEventListener('click', function() {
        loadPreset(this);
      });
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', addToCart);
    }

    // Initialize
    updateBoxPrices();
    updateTeaPrices();
    updatePresets();
    updateUI();
  })();

  } catch(e) { console.error(e); }
})();
})();
